import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Spin, Breadcrumb } from 'antd'
import { Redirect, Link, useLocation, Switch, Route } from 'react-router-dom'
import '../../css/patient.add.scss'
import util from '../../util/util'
import { PatientAdd as PatientComponents } from '../../component'
import { getSurgeonList } from '../../store/action/surgeon.action'

var {
  InfoForm,
  RegimenForm,
  ScheduleForm,
  CarePlanForm,
  EditDeviceForm,
  FeedbackForm,
} = PatientComponents

const PatientAdd = (props) => {
  var location = useLocation()

  useEffect(() => {
    props.fetchSurgeon(props.customer?._id)
  }, [])

  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Col className='patientAddContainer'>
          <Row>
            <Breadcrumb>
              {/* {location.state?.home && <Breadcrumb.Item><Link to="/home" >Home</Link></Breadcrumb.Item>} */}
              <Breadcrumb.Item>
                <Link to='/patient'>Patients</Link>
              </Breadcrumb.Item>
              {
                <Breadcrumb.Item>
                  {location.state?.patient?._id ? 'Edit' : 'Add'}
                </Breadcrumb.Item>
              }
            </Breadcrumb>
          </Row>
          <Switch>
            <Route exact path='/patient/add/info'>
              <InfoForm />
            </Route>
            <Route exact path='/patient/edit/info'>
              <InfoForm />
            </Route>

            <Route exact path='/patient/add/careplan'>
              <CarePlanForm />
            </Route>
            <Route exact path='/patient/add/devices'>
              <EditDeviceForm />
            </Route>

            <Route exact path='/patient/add/regimens'>
              <RegimenForm />
            </Route>

            <Route exact path='/patient/add/schedule'>
              <ScheduleForm />
            </Route>

            <Route exact path='/patient/add/questionnaire'>
              <FeedbackForm />
            </Route>
          </Switch>
        </Col>
      </Spin>
    </>
  )
}

PatientAdd.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string,
  customer: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    isLoading: state.profile.isLoading,
    customer: state.profile.customer,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSurgeon: (customerid) => dispatch(getSurgeonList(customerid)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientAdd)
